import React, { Fragment, useState } from "react";
import { Avatar, Dialog, DialogActions, DialogTitle, IconButton, List, ListItemAvatar, ListItemButton, ListItemText, ListSubheader, Menu, Stack, } from "@mui/material";
import { AddCircleIcon, CloseIcon, MoveDownCircleIcon, MoveUpCircleIcon, RemoveCircleIcon, TuningIcon } from "../icons";
import { useFlag } from "../utils";
function groupColumns(available) {
    const groups = {};
    const other = [];
    for (const column of available) {
        const group = column.group;
        if (group) {
            if (!groups[group]) {
                groups[group] = [column];
            }
            else {
                groups[group].push(column);
            }
        }
        else {
            other.push(column);
        }
    }
    return { groups, other };
}
export function DataTableColumnSettings(props) {
    const { columns, selected, onChange, labels, } = props;
    const [open, setOpen, clearOpen] = useFlag(false);
    const [focus, setFocus] = useState();
    const [addMenu, setAddMenu, clearAddMenu] = useFlag(false);
    const [addAnchor, setAddAnchor] = useState(null);
    const available = columns.filter(column => !selected.find(s => s.field == column.field));
    const { groups, other } = groupColumns(available);
    function move(sourceIndex, targetIndex) {
        const newSelected = [...selected];
        const temp = newSelected[targetIndex];
        newSelected[targetIndex] = newSelected[sourceIndex];
        newSelected[sourceIndex] = temp;
        onChange(newSelected);
    }
    function moveUp() {
        const index = selected.findIndex(s => s.field == focus);
        if (index >= 1) {
            move(index, index - 1);
        }
    }
    function moveDown() {
        const index = selected.findIndex(s => s.field == focus);
        if (index >= 0 && index + 1 < selected.length) {
            move(index, index + 1);
        }
    }
    function remove() {
        onChange(selected.filter(c => c.field != focus));
        setFocus(undefined);
    }
    function add(column) {
        onChange([...selected, column]);
        clearAddMenu();
    }
    function changeFocus(column) {
        setFocus(focus != column.field ? column.field : undefined);
    }
    function renderSelectListItems(columns) {
        return columns.map(column => (React.createElement(ListItemButton, { key: column.field, onClick: () => add(column) },
            React.createElement(ListItemText, { primary: column.label }))));
    }
    return (React.createElement(Fragment, null,
        React.createElement(IconButton, { onClick: setOpen, title: labels("title") },
            React.createElement(TuningIcon, null)),
        React.createElement(Dialog, { open: open, onClose: clearOpen, fullWidth: true, maxWidth: "xs" },
            React.createElement(DialogTitle, null, labels("title")),
            React.createElement(IconButton, { "aria-label": labels("close"), title: labels("close"), onClick: clearOpen, sx: {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                } },
                React.createElement(CloseIcon, null)),
            React.createElement(List, { sx: { flex: 1, overflowY: "scroll" } }, selected.map((column, index) => (React.createElement(ListItemButton, { key: column.field, onClick: () => changeFocus(column), selected: focus == column.field },
                React.createElement(ListItemAvatar, null,
                    React.createElement(Avatar, null, index + 1)),
                React.createElement(ListItemText, { primary: column.label, secondary: column.group }))))),
            React.createElement(DialogActions, null,
                React.createElement(Stack, { spacing: 2, direction: "row", justifyContent: "space-between", flex: 1 },
                    React.createElement(IconButton, { onClick: setAddMenu, ref: setAddAnchor, disabled: available.length == 0, color: "primary", title: labels("add"), size: "large" },
                        React.createElement(AddCircleIcon, { fontSize: "large" })),
                    React.createElement(Stack, { spacing: 2, direction: "row", justifyContent: "center" },
                        React.createElement(IconButton, { onClick: moveUp, disabled: !focus, color: "secondary", title: labels("moveUp"), size: "large" },
                            React.createElement(MoveUpCircleIcon, { fontSize: "large" })),
                        React.createElement(IconButton, { onClick: moveDown, disabled: !focus, color: "secondary", title: labels("moveDown"), size: "large" },
                            React.createElement(MoveDownCircleIcon, { fontSize: "large" }))),
                    React.createElement(IconButton, { onClick: remove, disabled: !focus, color: "error", title: labels("remove"), size: "large" },
                        React.createElement(RemoveCircleIcon, { fontSize: "large" })))),
            React.createElement(Menu, { open: addMenu, anchorEl: addAnchor, onClose: clearAddMenu },
                Object.entries(groups).map(([group, columns]) => (React.createElement(Fragment, null,
                    React.createElement(ListSubheader, null, group),
                    renderSelectListItems(columns)))),
                renderSelectListItems(other)))));
}
//# sourceMappingURL=DataTableColumnSettings.js.map